import env, { getRootUrl } from '@/constants/environment';
import * as Sentry from '@sentry/react';
import { BackofficeUserModel } from '@/typings/api/user';
import { BUILD_COMMIT_HASH } from '@/constants/version';

export function initializeSentry() {
  if (env.sentry) {
    // @ts-ignore
    const isProduction = BACKOFFICE_ENV === 'production';
    const isSandbox = location.hostname.includes('partners-sandbox');
    Sentry.init({
      dsn: env.sentry,
      // Tags every backoffice event with the build's short git SHA, so errors
      // in Sentry show which commit they came from. The release auto-creates on
      // ingest (the backoffice has its own Sentry project; the deploy.sh
      // `sentry-cli releases` calls are for the widget/hostbundle projects).
      release: BUILD_COMMIT_HASH,
      tracesSampleRate: 0,
      // @ts-ignore
      environment: isSandbox ? 'sandbox' : BACKOFFICE_ENV,
      ...((isProduction || isSandbox) && {
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        integrations: [Sentry.replayIntegration()],
      }),
    });
  }
}

const sentryExtras = new Set<string>();
export function setSentryExtraOnce(key: string, value: any) {
  if (sentryExtras.has(key)) return;
  sentryExtras.add(key);
  Sentry.setExtra(key, value);
}


export function setSentryUser(user: BackofficeUserModel) {
  const userId = user?.User?.alias;
  if (!userId) return;

  setSentryExtraOnce('user_id', userId);

  const currentPartner = user?.Partners?.find(
    (partner) => partner.current_partner,
  );
  const firstPartner = user?.Partners?.[0];
  const partnerId = currentPartner?.id || firstPartner?.id;

  setSentryExtraOnce('partner_id', partnerId);
  setSentryExtraOnce(
    'impersonate_url',
    `${getRootUrl()}/admin/users/impersonate_by_hash?hashed_user_id=${userId}`,
  );
}
